export default __webpack_public_path__ + "static/media/flag-conmenbol.a4ec3c59.png";